exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max[data-v-746cbddb]{max-width:30px}.date-width[data-v-746cbddb]{width:15%}.comment-width[data-v-746cbddb]{width:50%}tr td[data-v-746cbddb]{font-weight:300!important;font-size:.9em;color:#818080}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-746cbddb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VueSrc/SeminarTask/components/SeminarHistoryStatus.vue
// module id = 888
// module chunks = 0